import { render, staticRenderFns } from "./ProdutoTotais.vue?vue&type=template&id=759c31f5"
import script from "./ProdutoTotais.vue?vue&type=script&lang=js"
export * from "./ProdutoTotais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports